import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const UnderageError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">Thank You for your interest! However this facility is available to only customers who are 18 years of age and above.</Text>
      <Text className="error-description">Please visit your nearest branch for more details.</Text>
    </Fragment>
  )
}

export default UnderageError;
